import { useEffect, useState } from 'react';
import axios from 'axios';
import { AlertTriangle, XCircle, ChevronDown, ChevronUp } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Shows what will stop AI quote drafts from working well with this
 * business's catalog (missing prices on core items, missing core items,
 * planner problems). Renders nothing when the catalog is healthy.
 */
export function CatalogHealthBanner({ lang = 'tr', refreshKey = '' }) {
  const [report, setReport] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API_URL}/api/quote/ai/catalog-health`, { params: { language: lang } })
      .then(({ data }) => { if (!cancelled) setReport(data || null); })
      .catch(() => { if (!cancelled) setReport(null); });
    return () => { cancelled = true; };
  }, [lang, refreshKey]);

  if (!report || report.status === 'ok' || !(report.issues || []).length) return null;

  const isError = report.status === 'error';
  const Icon = isError ? XCircle : AlertTriangle;
  const box = isError
    ? 'border-red-200 bg-red-50 text-red-900'
    : 'border-amber-300 bg-amber-50 text-amber-900';
  const en = lang === 'en';
  const unpricedCore = report.unpriced_core || [];

  return (
    <div className={`mt-3 rounded-lg border p-3 text-sm ${box}`} data-testid="catalog-health-banner">
      <button
        type="button"
        className="w-full flex items-start justify-between gap-3 text-left"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="flex items-start gap-2">
          <Icon className="w-4 h-4 mt-0.5 shrink-0" />
          <span>
            <span className="font-medium">
              {en ? 'AI quote readiness' : 'AI teklif hazırlığı'}:
            </span>{' '}
            {report.issues[0].message}
            {report.issues.length > 1 && (
              <span className="opacity-80">
                {' '}{en ? `(+${report.issues.length - 1} more)` : `(+${report.issues.length - 1} bulgu)`}
              </span>
            )}
          </span>
        </span>
        {open ? <ChevronUp className="w-4 h-4 shrink-0" /> : <ChevronDown className="w-4 h-4 shrink-0" />}
      </button>
      {open && (
        <div className="mt-2 pl-6 space-y-1">
          {report.issues.slice(1).map((item) => (
            <p key={`${item.code}-${item.role || ''}`}>• {item.message}</p>
          ))}
          {unpricedCore.length > 0 && (
            <div className="pt-1">
              <p className="font-medium">
                {en ? 'Core items without a price:' : 'Fiyatı boş temel kalemler:'}
              </p>
              <ul className="list-disc pl-5 max-h-40 overflow-auto">
                {unpricedCore.map((item) => <li key={item.id}>{item.name}</li>)}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CatalogHealthBanner;
